export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export type TabbableState = {
  disabled: boolean;
  tabIndex: number;
  inert: boolean;
  visibility: string;
  hasLayout: boolean;
};

/** Whether the browser's own Tab order would visit the element (D7). */
export function isTabbable(s: TabbableState): boolean {
  return !s.disabled && s.tabIndex !== -1 && !s.inert && s.visibility === "visible" && s.hasLayout;
}

/** Focusable descendants in DOM order, minus hidden ones (e.g. Tailwind `invisible` tab panels). */
export function getFocusable(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter((el) =>
    isTabbable({
      disabled: el.hasAttribute("disabled"),
      tabIndex: el.tabIndex,
      inert: el.closest("[inert]") !== null,
      visibility: getComputedStyle(el).visibility,
      hasLayout: el.getClientRects().length > 0,
    })
  );
}
